export default __webpack_public_path__ + "static/media/visual_merchandising_bg.832e2fdd.png";